import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AgencyId = Brand<number, 'AgencyId'>;
export const AgencyId = createBranded<AgencyId>();
